
export class TweenMaxGroupHelper {
    public static disposeTweenMaxGroupInstance(instance: any): void {
        if (!instance) {
            return;
        }

        instance.destroy();
        instance = null;
    }
}
